import { PageHeader } from "@ant-design/pro-components";
import { observer } from 'mobx-react';
import React from "react";
import { useParams } from "react-router-dom";
import '../common/page-header.css';
import EditTaskPanel from "./edit-task-panel";
import { Button } from "antd";
import { RollbackOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import Subjects from "../../models/subjects";

const TaskEdit: React.FC<{subject: Subjects}> = ({subject}) => {

    const { taskId } = useParams();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <div className="content">
            <PageHeader title={`Редактирование задачи №${taskId}`} className="site-page-header"/>
            <Button type='link' onClick={handleGoBack}><RollbackOutlined />Вернуться</Button>
            <EditTaskPanel subject={subject}/>
        </div>
    );
};


export default observer(TaskEdit);